import React from 'react';
import { LayoutRoute } from '../../layout/routes';
import withLoading from '../../helpers/withLoading';

const SalesHomepage = withLoading(() => import('./'));

const route = <LayoutRoute path="/" exact component={SalesHomepage} />;

export default route;
